import { Button, Popconfirm, Space, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import useGetSearchColumnProps from '../../../../common/hooks/SearchData';
import { IPermission, ISetState } from '../../../../common/types/commonTypes';
import { useDeleteRoomTypesMutation } from '../endpoints/roomTypesEndpoints';
import { RoomTypeDataType } from '../types/roomTypesTypes';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../auth/states/userSlice';

type Props = {
  setEditInfo: ISetState<RoomTypeDataType | null>;
  showModal: () => void;
  permission?: IPermission;
  pagination: {
    current: number;
    pageSize: number;
  };
};

export const columns = ({
  pagination,
  setEditInfo,
  showModal,
  permission,
}: Props): ColumnsType<RoomTypeDataType> => {
  const [columnIndex, setColumnIndex] = useState<number | null>(null);
  const searchColumnProps = useGetSearchColumnProps<RoomTypeDataType>();
  const user = useSelector(selectUser);
  const handleClick = (record: RoomTypeDataType) => {
    setEditInfo(record);
    showModal();
  };

  /**
   * handle delete
   */
  const [deleteRoomType, { isError, isSuccess, isLoading }] =
    useDeleteRoomTypesMutation();
  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
      message.success('RoomTypes Deleted Successfully');
    } else if (isError) {
      setColumnIndex(null);
      message.error('Something went wrong');
    }
  }, [isSuccess, isError]);

  const handleDelete = async (values: RoomTypeDataType, index: number) => {
    setColumnIndex(index);
    await deleteRoomType({ ...values, deleted_by: user?.user_id });
  };

  return [
    {
      title: 'SL.',
      dataIndex: 'key',
      key: 'serial',
      render: (_, data, index) => (
        <>
          {((pagination.current || 1) - 1) * (pagination.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },
    {
      title: 'Room Type Name',
      dataIndex: 'rtype_name',
      key: 'rtype_name',

      ...searchColumnProps('rtype_name'),
    },
    {
      title: 'Action',
      key: 'action',

      render: (_, record, index) => (
        <Space size='small'>
          {permission?.['update:any'] && record.agency_id && (
            <Button
              size='small'
              type='primary'
              onClick={() => handleClick(record)}
            >
              Edit
            </Button>
          )}

          {permission?.['delete:any'] && record.agency_id && (
            <Popconfirm
              title='Sure to delete?'
              onConfirm={() => handleDelete(record, index)}
            >
              <Button
                danger
                size='small'
                type='primary'
                loading={columnIndex === index && true}
              >
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
};
